module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "ctn-toggle row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tEtes-vous intéressé par des critères de durabilité ?\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.interestedBySustainability
    },
    on: {
      "change": function($event) {
        return _vm.changeInterestedBySustainability($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.interestedBySustainability) ? _c('div', {
    staticClass: "ctn-tags row"
  }, _vm._l((_vm.durabilites), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag",
      class: {
        active: _vm.isActiveTag(tag),
        locked: _vm.isLocked(tag)
      },
      on: {
        "click": function($event) {
          return _vm.toggleTag(tag)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tag) + "\n\t\t\t")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctn-toggle row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tÊtes-vous prêt à accepter des performances moindres en cas d'investissements ESG ?\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.acceptLowerPerformance
    },
    on: {
      "change": function($event) {
        return _vm.changeAcceptLowerPerformance($event)
      }
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ff17661"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/MyPatrimonialLandscape/Esg.vue
// module id = 1112
// module chunks = 0